/* eslint-disable no-console */
import { PREVISIONAL_CHILE_2026 as PREV } from "../constants/previsional";
import { client } from "./supabase"; // cliente oficial, igual que en getUsers

export const getEmpleados = async (pais) => {
  try {
    const { data, error } = await client
      .from("empleados")
      .select("*")
      .eq("pais", pais)
      .order("apellido", { ascending: true })
      .order("nombre", { ascending: true });
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getEmpleados:", error);
    throw error;
  }
};

export const crearEmpleado = async (data) => {
  try {
    console.log("Datos enviados a insert:", data); // temporal para debug
    const { data: result, error } = await client.from("empleados").insert([data]).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en crearEmpleado:", error);
    throw error;
  }
};

export const actualizarEmpleado = async (id, data) => {
  try {
    const { data: result, error } = await client.from("empleados").update(data).eq("id", id).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en actualizarEmpleado:", error);
    throw error;
  }
};

export const getVacacionesEmpleado = async (empleadoId) => {
  try {
    const { data, error } = await client
      .from("vacaciones_empleado")
      .select("*")
      .eq("empleado_id", empleadoId)
      .order("fecha_inicio", { ascending: false });
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getVacacionesEmpleado:", error);
    throw error;
  }
};

// Todas las vacaciones del país — para vista de cards en Empleados (no N+1)
export const getVacacionesPais = async (pais) => {
  try {
    const { data, error } = await client
      .from("vacaciones_empleado")
      .select("*, empleados!inner(pais)")
      .eq("empleados.pais", pais)
      .order("fecha_inicio", { ascending: false });
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getVacacionesPais:", error);
    throw error;
  }
};

export const agregarVacaciones = async (data) => {
  try {
    const { data: result, error } = await client.from("vacaciones_empleado").insert([data]).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en agregarVacaciones:", error);
    throw error;
  }
};

// Cargar remuneraciones de un empleado
export const getRemuneracionesEmpleado = async (empleadoId) => {
  try {
    const { data, error } = await client
      .from("remuneraciones_empleado")
      .select("*")
      .eq("empleado_id", empleadoId)
      .order("inicio_vigencia", { ascending: true });
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getRemuneracionesEmpleado:", error);
    throw error;
  }
};

// Crear nueva remuneración
export const crearRemuneracion = async (data) => {
  try {
    const { data: result, error } = await client.from("remuneraciones_empleado").insert([data]).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en crearRemuneracion:", error);
    throw error;
  }
};

// Actualizar remuneración existente
export const actualizarRemuneracion = async (id, data) => {
  try {
    const { data: result, error } = await client.from("remuneraciones_empleado").update(data).eq("id", id).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en actualizarRemuneracion:", error);
    throw error;
  }
};

// Escala impuesto único Chile. Los tramos y rebajas están expresados en múltiplos de UTM,
// así que escalan con el valor real del mes. Se recibe la UTM del mes liquidado (getUTMValue
// desde el componente); 71506 (UTM 2026-06) queda solo como fallback si no llega el parámetro,
// para no romper llamadas existentes.
const calcularImpuestoUnico = (base, utm) => {
  const UTM = Number(utm) > 0 ? Number(utm) : 71506;
  if (base <= 13.5 * UTM) return 0;
  if (base <= 30 * UTM) return Math.max(0, Math.round(base * 0.04 - 0.54 * UTM));
  if (base <= 50 * UTM) return Math.max(0, Math.round(base * 0.08 - 1.74 * UTM));
  if (base <= 70 * UTM) return Math.max(0, Math.round(base * 0.135 - 4.49 * UTM));
  if (base <= 90 * UTM) return Math.max(0, Math.round(base * 0.23 - 11.14 * UTM));
  if (base <= 120 * UTM) return Math.max(0, Math.round(base * 0.304 - 17.8 * UTM));
  if (base <= 310 * UTM) return Math.max(0, Math.round(base * 0.35 - 23.32 * UTM));
  return Math.max(0, Math.round(base * 0.4 - 38.82 * UTM));
};

/**
 * Calcula la liquidación mensual Chile a partir de los datos de remuneración.
 * Fuente de verdad: recibos de sueldo reales (Franco, Nico, Jorge — abril 2026).
 * Cuadra exacto si la remuneración trae bonos_fijo/variable cargados y se pasa
 * el ufDelMes correcto para empleados con Isapre.
 *
 * @param {Object} rem - Remuneración vigente: sueldo_base, bonos_fijo, bonos_variable,
 *                       afp_cap_individual_pct, afp_comision_pct, salud_tipo, salud_isapre_uf.
 * @param {number} ufDelMes - Valor UF del mes (necesario para Isapre).
 * @param {number} descuentosVarios - Anticipos, préstamos u otros descuentos no legales.
 * @param {number} utmDelMes - Valor UTM del mes liquidado (tramos del impuesto único).
 *                             Si no llega, calcularImpuestoUnico cae a la UTM de fallback.
 * @param {Array<{monto:number, imponible?:boolean}>} haberesMes - Haberes atados a ESTE mes
 *                       puntual (bono one-off, comisión del mes), a diferencia de bonos_fijo/
 *                       variable que son fijos toda la vigencia. Los imponibles (imponible !==
 *                       false) suman al imponible y a la base de gratificación. Default [] →
 *                       comportamiento idéntico al actual (retrocompatible).
 */
export const calcularLiquidacionChile = (rem, ufDelMes = 0, descuentosVarios = 0, utmDelMes = 0, haberesMes = []) => {
  const sueldoBase = Number(rem.sueldo_base) || 0;
  const bonosFijo = Number(rem.bonos_fijo) || 0;
  const bonosVariable = Number(rem.bonos_variable) || 0;
  // Haberes imponibles del mes (bono one-off, comisión): Σ de los que NO son explícitamente no
  // imponibles. Se suman igual que los bonos, pero atados al mes en curso (no a la vigencia).
  const haberesImponibles = (haberesMes || []).reduce(
    (acc, h) => acc + (h && h.imponible !== false ? Number(h.monto) || 0 : 0),
    0
  );
  // Gratificación: 25% del imponible base (sueldo + bonos + haberes imponibles), topeada al máximo.
  const gratificacion = Math.min(
    Math.round(0.25 * (sueldoBase + bonosFijo + bonosVariable + haberesImponibles)),
    PREV.topeGratificacionMensual
  );
  // Imponible incluye bonos imponibles y los haberes imponibles del mes. Bonificaciones no
  // imponibles (movilización, colación, asignación familiar) NO se suman acá — pagos separados.
  const totalImponible = sueldoBase + gratificacion + bonosFijo + bonosVariable + haberesImponibles;

  // Tope imponible legal (en UF). Si no hay UF cargada (ufDelMes<=0) no se topea, para no
  // colapsar la base a 0. AFP/salud comparten tope; cesantía tiene su propio tope (mayor).
  const topeAfpSalud = ufDelMes > 0 ? Math.round(PREV.topeImponibleUF * ufDelMes) : Infinity;
  const topeCesantia = ufDelMes > 0 ? Math.round(PREV.topeImponibleCesantiaUF * ufDelMes) : Infinity;
  const baseAfpSalud = Math.min(totalImponible, topeAfpSalud);
  const baseCesantia = Math.min(totalImponible, topeCesantia);

  // AFP — capitalización individual (10% default) + comisión variable de la AFP.
  // Se redondea el TOTAL una sola vez; la comisión se deriva como resto (total − cap) para
  // no arrastrar ±1 peso de redondear cada parte por separado.
  const capPct = rem.afp_cap_individual_pct ?? 10;
  const comisionPct = rem.afp_comision_pct || 0;
  const totalAfp = Math.round(baseAfpSalud * ((capPct + comisionPct) / 100));
  const capIndividual = Math.round(baseAfpSalud * (capPct / 100));
  const comisionAfp = totalAfp - capIndividual;

  // Salud — Fonasa: 7% del imponible topeado. Isapre: max(UF×valorUF, 7%) — el 7% es piso legal.
  let totalSalud = 0;
  if (rem.salud_tipo === "fonasa") {
    totalSalud = Math.round(baseAfpSalud * 0.07);
  } else if (rem.salud_tipo === "isapre") {
    const ufCargo = rem.salud_isapre_uf && ufDelMes > 0 ? Math.round(Number(rem.salud_isapre_uf) * ufDelMes) : 0;
    const pisoLegal = Math.round(baseAfpSalud * 0.07);
    totalSalud = Math.max(ufCargo, pisoLegal);
  }

  // Seguro cesantía trabajador (0.6% imponible topeado).
  const segCesantia = Math.round(baseCesantia * 0.006);

  // Base impuesto único = imponible - AFP - salud - cesantía (los 3 descuentos previsionales).
  const baseImpuesto = totalImponible - totalAfp - totalSalud - segCesantia;
  const impuestoUnico = calcularImpuestoUnico(baseImpuesto, utmDelMes);

  const totalDescuentosLegales = totalAfp + totalSalud + segCesantia + impuestoUnico;
  const descVar = Number(descuentosVarios) || 0;
  const totalDescuentos = totalDescuentosLegales + descVar;
  const liquido = totalImponible - totalDescuentos;

  // Carga patronal (SIS + cesantía patronal + mutual aprox): la paga el EMPLEADOR por PreviRed,
  // NO se descuenta al empleado ni afecta el líquido. Dato extra para la proyección de PreviRed.
  const cargaPatronal = Math.round(totalImponible * PREV.cargaPatronalPct);

  return {
    sueldoBase,
    gratificacion,
    bonosFijo,
    bonosVariable,
    haberesImponibles,
    totalImponible,
    capIndividual,
    comisionAfp,
    totalAfp,
    totalSalud,
    segCesantia,
    baseImpuesto,
    impuestoUnico,
    totalDescuentosLegales,
    descuentosVarios: descVar,
    totalDescuentos,
    liquido,
    cargaPatronal,
  };
};
